<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center" id="page-login">
    <div class="content-wrapper vx-col sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 sm:m-0 m-4">
      <div class="logo-wrapper w-full flex flex-col text-center">
        <h1 class="arf-logo">
          <i class=" fa fa-leaf green"></i>
          <span class="green">O</span><span class="grey">yis</span>
        </h1>
        <h4 class="blue ">Orman Yangın İzleme Sistemi</h4>
      </div>
      <vx-card class="login-form" no-radius>
        <div slot="no-body" class="">
          <div class="vx-row no-gutter flex-col justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-full ">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="header blue lighter big bb-1"><i class="ace-icon fa fa-chrome green"></i><span>Lütfen Oturum Bilgilerinizi Giriniz</span></h4>
                </div>

                <div>
                  <vs-input
                      name="email"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      ref="email"
                      v-model="email"
                      @keyup.enter="login"
                      class="w-full small"/>

                  <vs-input
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      v-model="password"
                      @keyup.enter="login"
                      class="w-full mt-6" />

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3 check">Beni hatırla</vs-checkbox>
                    <vs-button class="float-right text-white mb-4 blue-bg p-0" @click="login"><i class="ace-icon fa fa-key"></i>Giriş</vs-button>
                  </div>

                </div>

              </div>

              <div class=" vx-row m-0 py-2 w-full flex flex-wrap justify-between blue-bg routing-link">

                <div class="vx-col w-1/2  m-0"><router-link class="yellow" to=""><i class="ace-icon fa fa-arrow-left"></i>Şifremi unuttum?</router-link></div>
                <div class="vx-col w-1/2  m-0"><router-link class="green" to="">Hesap oluşturmak istiyorum?<i class="ace-icon fa fa-arrow-right"></i></router-link></div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{
  data () {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      inputIsVisible: false
    }
  },
  mounted () {
    this.emailClick()
  },
  methods: {
    emailClick () {
      this.$refs.email.$el.focus()
    },
    login () {
      const loginuser = {
        email: this.email, //'serkan.erdinc@asay.com.tr',
        password: this.password
      }

      this.$store.dispatch('loginUser', loginuser)
        .then((response) => {
          console.log('success')
          if (this.checkbox_remember_me) {
            localStorage.setItem('email', this.email)
            localStorage.setItem('password', this.password)
          }
          localStorage.setItem('check', this.checkbox_remember_me)

          this.$vs.notify({
            title: 'Başarılı',
            text: response.data.message,
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.$router.push('/')
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log('error')
          console.log(error)
          this.$vs.notify({
            title: 'Hata',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })

          this.$router.push('/pages/login')
        })
    }
  }
}
</script>

<style lang="scss">
#page-login {
  .vs-input--input.normal ~ .vs-input--icon.feather {
    top: 4px !important;
    color: #0C112E !important;
  }
  .vs-button {
    border: 5px solid #478FCA;
    border-radius: 5px;
  }
  .routing-link {
    .green {
      color:#CF7 !important;
    }
    .yellow {
      color: #FE9 !important;
    }
    a {
      font-size: 10px;
    }
  }
  .vx-card input {
    background: white;
    font-size: 14px !important;
    padding-right: 5px !important;
    padding-bottom: 5px !important;
    padding-top: 5px !important;
    padding-left: 2rem !important;

  }
  .vs-input--input:focus {

    border-color: #F59942 !important;
  }
  .vs-checkbox-primary input:checked+.vs-checkbox {
    background: #F59942;
  }
  .check {
    font-size: 12px;
  }
  .logo-wrapper {
    margin-top: 60px;
  }
  .login-form {
    margin-top: 30px;
    background: #F7F7F7 !important;
  }
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
  .content-wrapper {
    max-width: 375px;
  }
  .header.big {
    padding: 8px 4px;
  }
}
</style>
